import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Box
} from "@mui/material";
import { useState } from "react";
import { format } from "date-fns";
import { dateDifference, formatDate, formatDateText } from "../CommonFunctions";

export default function CheckoutDialog({
  open,
  onClose,
  tenancyDetails,
  handleCheckout
}) {




  const [actualCheckoutDate, setActualCheckoutDate] = useState(tenancyDetails.checkout);

  // Calculate stay duration dynamically
 

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Confirm Checkout</DialogTitle>

      <DialogContent dividers>
        <Box>
            <Typography color="error" fontWeight={600} mb={0} mt={0}>
          Are you sure you want to check out this tenant?
        </Typography>
          <b>Room:</b> {tenancyDetails.roomid}<br></br>
          <b>Check-in:</b>{" "}
            {tenancyDetails.checkin ? 
            formatDateText(tenancyDetails.checkin) : "—"}<br></br>
            <b>Scheduled Checkout:</b>{" "}
            {tenancyDetails.checkout
              ? formatDateText(tenancyDetails.checkout)
              : "—"}
        </Box>

        {/* Actual Checkout Input */}
        <Box mt={4}>
          <TextField
            label="Actual Checkout Date"
            type="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={actualCheckoutDate}
            onChange={(e) => setActualCheckoutDate(e.target.value)}
          />
        </Box>

        
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>

        <Button
          variant="contained"
          disabled={!actualCheckoutDate}
          onClick={() => {
            handleCheckout(actualCheckoutDate, "checked-out")
            onClose();
        }
          }
        >
          Confirm Checkout
        </Button>
      </DialogActions>
    </Dialog>
  );
}
